/**
 * LG webOS CastingProvider — FOUNDATION + REQUIRES NATIVE RECEIVER.
 *
 * Pure web discovery/control of LG TVs is not supported from this SPA.
 * A branded webOS app (or native shell with Connect SDK) is required.
 */

import { CastingCapabilityState } from "./CastingEvents";
import { CastPlatformReceiverRequirements } from "./CastReceiverContract";
import { createReceiverRequiredProvider } from "./createReceiverRequiredProvider";

export function createLGTVProvider(options) {
  var req = CastPlatformReceiverRequirements.lg;
  return createReceiverRequiredProvider(
    {
      id: "lg",
      displayName: "LG TV",
      capabilityState: CastingCapabilityState.REQUIRES_RECEIVER_APP,
      reason: req.mechanism,
      receiverContract: {
        appIdField: "lgAppId",
        platform: "webos",
        sessionModel: "CastReceiverSession",
        note: "Install branded webOS app before marking operational.",
      },
    },
    options
  );
}

export default createLGTVProvider;
